import Immutable, { List } from 'immutable';

interface RawProjectDriveSourceTarget {
  itemType: 'file' | 'folder';
  driveId: string;
  id: string;
  folderPathIds: string[];
  siteId?: string;
}

interface ProjectDriveSourceTargetData {
  itemType: 'file' | 'folder';
  driveId: string;
  id: string;
  folderPathIds: List<string>;
  siteId?: string;
}

const defaultValues: ProjectDriveSourceTargetData = {
  itemType: 'file',
  driveId: '',
  id: '',
  folderPathIds: List<string>(),
  siteId: undefined,
};

export const ProjectDriveSourceTargetFactory = Immutable.Record(
  defaultValues,
  'ProjectDriveSourceTarget'
);

export class ProjectDriveSourceTarget extends ProjectDriveSourceTargetFactory {
  static deserialize(
    rawProjectDriveSourceTarget: RawProjectDriveSourceTarget
  ): ProjectDriveSourceTarget {
    const { folderPathIds: folderPath } = rawProjectDriveSourceTarget;

    return new ProjectDriveSourceTarget({
      ...rawProjectDriveSourceTarget,
      folderPathIds: List(folderPath),
    });
  }

  serialize(): RawProjectDriveSourceTarget {
    return this.toJS();
  }
}
